import React from 'react';
import { Button, Modal } from 'antd';
import { captureAnalytics } from '../../actions/preload';

const confirmEmaRepeatUpload = ({ canCreateTask }) => new Promise((resolve) => {
  let settled = false;
  const choose = (action) => {
    if (settled) return;
    settled = true;
    captureAnalytics('ema_repeat_upload_confirmation_resolved', { action });
    resolve(action);
  };
  captureAnalytics('ema_repeat_upload_confirmation_shown', { can_create_task: canCreateTask });
  const dialog = Modal.confirm({
    title: 'This document is already in the EMA chart',
    content: (
      <div>
        <p>Uploading again will add another copy of this document to the chart.</p>
        {canCreateTask && (
          <div>
            <p>You can create the task without attaching another document.</p>
            <Button
              onClick={() => {
                choose('task_only');
                dialog.destroy();
              }}
            >
              Create task only
            </Button>
          </div>
        )}
      </div>
    ),
    okText: 'Upload another copy',
    cancelText: 'Cancel',
    onOk: () => choose('upload_again'),
    onCancel: () => choose('cancel'),
  });
});

export default confirmEmaRepeatUpload;
